import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Layout from './Pages/Layout/Layout.jsx';
import About from './Pages/About/About.jsx';
import Resume from './Pages/Resume/Resume.jsx';
import Projects from './Pages/Projects/Projects.jsx';
import Contacts from './Pages/Contacts/Contacts.jsx';
import NotFound from './Pages/NotFound/NotFound.jsx';

function App() {

  let router = createBrowserRouter([
    {
      path: '', element: <Layout />, children: [
        { index: true, element: <About /> },
        { path: 'resume', element: <Resume /> },
        { path: 'projects', element: <Projects /> },
        { path: 'contacts', element: <Contacts /> },
        { path: '*', element: <NotFound /> },
      ]
    },
  ]);

  return (<div className='bg-[#E9F2FB] min-h-[100vh] '>
    <RouterProvider router={router}></RouterProvider>
  </div>);
}

export default App;
